import * as React from 'react';
import { FavoriteToggler } from '../FavoriteToggler/FavoriteToggler';
import { logEvent } from '../Util/logEvent';

export interface IVmsFavoriteTogglerProps {
    currentVmsId: string;
    currentRegion: string;
}

export const VmsFavoriteToggler: React.FC<IVmsFavoriteTogglerProps> = ({ currentVmsId, currentRegion }) => {
    const onFavoriteChange = (isFavorite: boolean) => {
        if (isFavorite) {
            logEvent('VMS', 'Add favorite', `VMS page id: ${currentVmsId}`);
        } else {
            logEvent('VMS', 'Remove favorite', `VMS page id: ${currentVmsId}`);
        }
    };

    return (
        <FavoriteToggler currentItemId={currentVmsId} storageKey={`MySignPages${currentRegion.toUpperCase()}`} onFavoriteChange={onFavoriteChange} />
    );
};
